module.exports = __webpack_public_path__ + "assets/images/UNFIT50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT50.png
// module id = 1444
// module chunks = 1